import * as H from 'history'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { mk_widget, Widget } from 'widgets-for-react'
import { allLanguages, defaultLanguage, oldSites } from '../../../public_site.main.mod'
import { getRegions, RegionLanguage } from '../../drupal/api/api.mod'
import { Locale, MenuItem } from '../../drupal/types_and_parser/extra_types.mod'

export interface HistoryEvent {
  location: H.Location<any>
  action: H.Action
}

export interface HistoryProps {
  onDone: (_: HistoryEvent) => void
}

export class HistoryComponent extends React.Component<RouteComponentProps & HistoryProps, {}> {
  private listener: H.UnregisterCallback

  constructor(props: RouteComponentProps & HistoryProps, context: any) {
    super(props, context)
    this.state = {}
  }

  componentDidMount() {
    this.listener = this.props.history.listen((location: H.Location<any>, action: H.Action) => {
      this.props.on_done({ location, action })
    })
  }

  componentWillUnmount() {
    this.listener()
  }

  render() {
    return null
  }
}

const HistoryComponentWithRouter = withRouter(HistoryComponent)

const history = (): Widget<HistoryEvent> => {
  return mk_widget({
    run: (onDone: (output: HistoryEvent) => void) =>
      React.createElement<HistoryProps>(HistoryComponentWithRouter, {
        onDone: onDone
      })
  })
}

export const localizeMenu = (menuItems: MenuItem[], newLang: string): MenuItem[] => {
  return menuItems.map((i) => ({
    ...i,
    relative: i.relative ? updateUrlLang(i.relative, newLang) : i.relative,
    below: i.below ? localizeMenu(i.below, newLang) : i.below
  }))
}

export const addLangToUrl = (url: string): string => {
  const language = getLangFromUrl()
  // return language == defaultLanguage ? url : `/${language}${url}`
  return `/${language}${url}`
}

/*
 * All Drupal URLs will be prefixed with a Language code
 * This code must be replace by the current Region or Locale code
 */
export const updateUrlLang = (url: string, newLang: string): string => {
  if (url?.startsWith('/')) {
    url = url.slice(1)
  }
  const path = url.split('/').slice(1).join('/')

  // If the requested language is the default language, we'll leave the url untouched
  return `/${newLang}/${path}`
}

export const getLangFromUrl: () => Locale = () => {
  let lang: Locale = defaultLanguage
  if (window.location.pathname != '/') {
    const pathSplit = window.location.pathname.split('/')
    if (pathSplit.length > 1) {
      lang = pathSplit[1] as Locale
    }
  }

  // Fix for previews on www.refresco.es
  if (lang == 'ib' as Locale) return 'es'

  return allLanguages.includes(lang) ? lang : defaultLanguage
}

//example of url: en/xyz
//not good url: /en/xyz
export const removeLangFromUrl = (url: string) => {
  let url1 = url
  if (url != '/') {
    const pathSplit = url.split('/')
    if (pathSplit.length > 1) {
      url1 = pathSplit.splice(1).join('/')
    }
  }
  return url1
}

export const getLangFromHost = () : Locale => {
  return oldSites.filter((v, k) => window.location.toString().startsWith(v)).map((v, k) => k).first() || defaultLanguage
}

export default history
